var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkSuccess(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03711 13.4316C10.5083 13.4316 13.3223 10.6177 13.3223 7.14648C13.3223 3.67529 10.5083 0.861328 7.03711 0.861328C3.56591 0.861328 0.751953 3.67529 0.751953 7.14648C0.751953 10.6177 3.56591 13.4316 7.03711 13.4316Z",
    fill: "#29C18C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03711 1.36133C3.84206 1.36133 1.25195 3.95143 1.25195 7.14648C1.25195 10.3415 3.84206 12.9316 7.03711 12.9316C10.2322 12.9316 12.8223 10.3415 12.8223 7.14648C12.8223 3.95143 10.2322 1.36133 7.03711 1.36133ZM0.251953 7.14648C0.251953 3.39915 3.28977 0.361328 7.03711 0.361328C10.7844 0.361328 13.8223 3.39915 13.8223 7.14648C13.8223 10.8938 10.7844 13.9316 7.03711 13.9316C3.28977 13.9316 0.251953 10.8938 0.251953 7.14648ZM10.8824 4.69788C11.0777 4.89314 11.0777 5.20972 10.8824 5.40499L5.99395 10.2935C5.79869 10.4887 5.4821 10.4887 5.28684 10.2935L3.19176 8.19839C2.9965 8.00313 2.9965 7.68655 3.19176 7.49128C3.38702 7.29602 3.7036 7.29602 3.89887 7.49128L5.64039 9.23279L10.1753 4.69788C10.3706 4.50262 10.6872 4.50262 10.8824 4.69788Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSuccess);
export default __webpack_public_path__ + "static/media/linkSuccess.2c4f2ce49c33eaddf85ede2b89a92b96.svg";
export { ForwardRef as ReactComponent };